// extracted by mini-css-extract-plugin
module.exports = {"sectionWrapper":"Event_sectionWrapper__2J5sZ","title":"Event_title__GzgMX","withRoundedBorder":"Event_withRoundedBorder__56SV8","program":"Event_program__1mBlr"};